import * as React from 'react';

import MinusSquare from 'crehana-icons/MinusSquare';
import PlusSquare from 'crehana-icons/PlusSquare';

import PrimaryButton from 'crehana-ui/Buttons/PrimaryButton';

import { CourseCardProps } from 'Jsx/Shared/CourseCardV3/types';
import { useTranslation } from 'Shared/Hooks/useTranslation';

const AddToPack: React.FC<Partial<CourseCardProps>> = ({
  courseInPack,
  validateAddCustomBundle,
  fullCustomBundle,
}) => {
  const { t } = useTranslation('main-menu');

  return (
    <div className="flex items-center pt-16">
      <PrimaryButton
        full
        gray={courseInPack}
        onClick={validateAddCustomBundle}
        disabled={fullCustomBundle && !courseInPack}
        leftIcon={{
          component: courseInPack ? MinusSquare : PlusSquare,
          size: 24,
        }}
        label={
          courseInPack
            ? t('REMOVE_COURSE_FROM_PACK', 'Quitar curso')
            : t('ADD_COURSE_TO_PACK', 'Agregar al pack')
        }
        size="m"
        className="w-full"
      />
    </div>
  );
};

export default AddToPack;
